'use strict';

exports.__esModule = true;
exports.default = TabPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabPanel(_ref, _ref2) {
  var children = _ref.children,
      className = _ref.className,
      tabId = _ref.tabId;
  var selectedTabId = _ref2.selectedTabId;

  return tabId === selectedTabId && _react2.default.createElement(
    'section',
    { className: (0, _classnames2.default)('TabPanel', className) },
    children
  );
}

TabPanel.propTypes = {
  children: _propTypes2.default.node,
  tabId: _propTypes2.default.any.isRequired
};

TabPanel.contextTypes = {
  selectedTabId: _propTypes2.default.any
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-context-tabs/lib/TabPanel.js
// module id = 904
// module chunks = 0